<template lang="pug">
  div
    template(v-if="false")
      a(v-if="isPc" href='/gifts/ochugen/' @click="$_gaSendEvent($route.path, 'ヘッダー共通バナーPC', 'お中元')")
        img(src="https://cdn.taberutokurasuto.com/image/gift/ochugen/2020/banner_pc.jpg" class='img-responsive banner')
      a(v-else href='/gifts/ochugen/' @click="$_gaSendEvent($route.path, 'ヘッダー共通バナーSP', 'お中元')")
        img(src="https://cdn.taberutokurasuto.com/image/gift/ochugen/2020/banner_sp.jpg" class='img-responsive _mb-10')
    template(v-if="false")
      a(v-if="isPc" href='/gifts/oseibo/' @click="$_gaSendEvent($route.path, 'ヘッダー共通バナーPC', 'お歳暮')")
        img(src="https://cdn.taberutokurasuto.com/image/gift/oseibo/banner_pc.jpg" class='img-responsive ')
      a(v-else href='/gifts/oseibo/' @click="$_gaSendEvent($route.path, 'ヘッダー共通バナーSP', 'お歳暮')")
        img(src="https://cdn.taberutokurasuto.com/image/gift/oseibo/banner_sp.jpg" class='img-responsive _mb-10')



</template>

<script>
  import GlobalMixin from "../../mixin/GlobalMixin";

  export default {
    name: "full-width-banner",
    mixins: [GlobalMixin],
    components: {
    },
    data: function () {
      return {
      }
    },
    computed: {
      isPc() {
        return this.$store.getters.isPc
      }
    }
  }
</script>

<style lang="scss" scoped>
    .banner{
        margin: 0 auto;
    }
</style>
